import "./Searchbar.css";
type SearchbarProps = {
  action: (value: string) => void;
  placeholder: string;
};
const Searchbar = ({ action, placeholder }: SearchbarProps) => {
  return (
    <div className="tool-searchbar">
      <label htmlFor="search-for-item" className="sr-only">
        {placeholder}
      </label>
      <input
        type="text"
        id="search-for-item"
        placeholder={placeholder}
        onChange={(e) => action(e.currentTarget.value)}
      />
    </div>
  );
};
export default Searchbar;
